import {
  SidebarMenuButton,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { SidebarSubMenuItemProps } from "@/types/index.type";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
const RSubMenuSidebarItem = ({
  title,
  Icon,
  path,
}: SidebarSubMenuItemProps) => {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState<boolean>(false);
  return (
    <SidebarMenuSubItem key={title}>
      {path ? (
        <NavLink
          to={path}
          className={({ isActive }) => {
            setIsActive(isActive);
            return "";
          }}
        >
          <SidebarMenuButton className="cursor-pointer" isActive={isActive}>
            {Icon && <Icon className="[&>svg]:no"/>}
            <span>{t(title)}</span>
          </SidebarMenuButton>
        </NavLink>
      ) : (
        <SidebarMenuSubButton className="cursor-pointer text-sidebar-foreground">
          {Icon && <Icon />}
          <span>{t(title)}</span>
        </SidebarMenuSubButton>
      )}
    </SidebarMenuSubItem>
  );
};

export default RSubMenuSidebarItem;
